import { EyeIcon, EyeOffIcon } from "lucide-react";
import { useState } from "react";
import QRCode from "react-qr-code";
import Separator from "../Separator";
import { Button } from "../ui/button";
import { TutorFormDataI } from "./TutorRegistration";
import { tutorSubjects } from "./TutorRegistrationStepOne";

const PortalDataCard = ({ formData }: { formData: TutorFormDataI }) => {
  const [showPassword, setShowPassword] = useState<boolean>(false);

  return (
    <div className="text-right">
      <h4 className="p-2 mb-2 text-green-600 text-center font-bold text-2xl">
        تم إنشاء المنصة بنجاح
      </h4>

      <p className="p-2 text-center font-bold leading-8">
        أهلا بك في عائلة كشكول، هذه هي بيانات منصتك الخاصة، يرجى الإحتفاظ بصورة
        أو لقطة للشاشة لهذه البيانات
      </p>

      <Separator />

      <div className="space-y-4">
        <p>
          <span className="text-primary font-bold">إسم المدرس :</span>{" "}
          {formData.name}
        </p>
        <p>
          <span className="text-primary font-bold">رقم الهاتف :</span>{" "}
          {formData.phone}
        </p>
        <p>
          <span className="text-primary font-bold">رقم الواتساب :</span>{" "}
          {formData.whatsapp}
        </p>
        <p>
          <span className="text-primary font-bold">الإيميل :</span>{" "}
          {formData.email}
        </p>

        <p className="flex items-center gap-2">
          <span className="text-primary font-bold">كلمة السر :</span>{" "}
          {showPassword
            ? formData.password
            : "•".repeat(formData.password.length)}
          <Button
            variant="link"
            className="p-0"
            onClick={() => setShowPassword((prev) => !prev)}
          >
            {showPassword ? (
              <EyeOffIcon className="size-6" />
            ) : (
              <EyeIcon className="size-6" />
            )}
          </Button>
        </p>

        <p>
          <span className="text-primary font-bold">المادة الدراسية :</span>{" "}
          {formData.subject === "other"
            ? formData.other_subject
            : tutorSubjects.find((s) => s.key === formData.subject)?.name}
        </p>
      </div>

      <Separator />

      <div className="flex flex-col items-center justify-center gap-2 text-center mt-4 text-xl">
        <p>يمكنك زيارة المنصة من هذا الرابط</p>

        <a
          href={`https://${formData.subdomain}.qashqool.com`}
          target="_blank"
          rel="noreferrer"
          className="text-primary font-bold underline"
        >
          {formData.subdomain}.qashqool.com
        </a>

        <p>
          أو <strong>scan</strong> الكود
        </p>
        <div className="mt-3 w-[70%] max-w-xs">
          <QRCode
            size={256}
            className="mx-auto"
            value={`https://${formData.subdomain}.qashqool.com`}
          />
        </div>
      </div>
    </div>
  );

  // return (
  //   <div>
  //     <h4 className="p-2 mb-2 text-success text-center fw-bold">
  //       تم إنشاء المنصة بنجاح
  //     </h4>
  //     <p className="p-2 text-center fw-bold">
  //       أهلا بك في عائلة كشكول ، هذه هي بيانات منصتك الخاصة، يرجى الإحتفاظ بصورة
  //       أو لقطة للشاشة لهذه البيانات
  //     </p>
  //     <Separator />
  //     <p>
  //       <span className="text-ea-primary fw-bold">إسم المدرس :</span>{" "}
  //       {formData.name}
  //     </p>
  //     <p>
  //       <span className="text-ea-primary fw-bold">رقم الهاتف :</span>{" "}
  //       {formData.phone}
  //     </p>
  //     <p>
  //       <span className="text-ea-primary fw-bold">رقم الواتساب :</span>{" "}
  //       {formData.whatsapp}
  //     </p>
  //     <p>
  //       <span className="text-ea-primary fw-bold">الإيميل :</span>{" "}
  //       {formData.email}
  //     </p>
  //     <p className="d-flex gap-2 align-items-center">
  //       <span className="text-ea-primary fw-bold">كلمة السر :</span>{" "}
  //       {showPassword
  //         ? formData.password
  //         : "•".repeat(formData.password.length)}
  //       <i
  //         className={`bi bi-eye-${
  //           showPassword ? "fill" : "slash"
  //         } fs-4 my-auto text-ea-primary`}
  //         style={{ cursor: "pointer" }}
  //         onClick={() => setShowPassword((prev) => !prev)}
  //       ></i>
  //     </p>
  //     <p>
  //       <span className="text-ea-primary fw-bold">المادة الدراسية :</span>{" "}
  //       {formData.subject === "other"
  //         ? formData.other_subject
  //         : tutorSubjects.find((s) => s.key === formData.subject)?.name}
  //     </p>
  //     <Separator />
  //     <div className="d-flex gap-2 align-items-center justify-content-center flex-column text-center">
  //       <p>
  //         يمكنك زيارة المنصة من هذا الرابط أو <strong>scan</strong> الكود
  //       </p>
  //       <a
  //         href={`https://${formData.subdomain}.qashqool.com`}
  //         target="_blank"
  //         rel="noreferrer"
  //         className="text-ea-primary fw-bold"
  //       >
  //         {formData.subdomain}.qashqool.com
  //       </a>
  //       <div className="text-center">
  //         <QRCode
  //           size={256}
  //           style={{
  //             height: "auto",
  //             minWidth: "70%",
  //           }}
  //           className="m-3 qrcode"
  //           value={`https://${formData.subdomain}.qashqool.com`}
  //           // viewBox={`0 0 256 256`}
  //         />
  //       </div>
  //     </div>
  //   </div>
  // );
};

export default PortalDataCard;
